export const generalEnums = {
  TIMESHEET: 'Timesheet',
  EXPENSE: 'Expense',
  DATEFORMAT: 'YYYY-MM-DD',
  DATEFIRSTFORMAT: 'DD/MM/YYYY',
  DATEWITH_MMM: 'DD MMM YYYY',
  DATEANDMONTH: 'DD MMM',
  SIGNINPOLICY: 'B2C_1A_SUSI_WITH_TANDC',
  MAGICLINKPOLICY: 'B2C_1A_SIGNIN_CLIENT'
};

export const idTokenClaims = {
  IS_TNE_APPROVER: 'extension_IsTAndEApprover',
  IS_TNE_CONTRACTOR: 'extension_IsTAndEUser',
  IS_TIFO_USER: 'extension_IsTifoUser'
};

export const submissionEnum = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
};

export const rateEnum = {
  DAILY: 'daily',
  HOURLY: 'hourly'
};

export const verticalPositions = {
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom'
};

export const horiontalPositions = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
